import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2,
  FormFieldV2 as FormField,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import type { SearchFieldActions, SearchFieldState } from '../../hooks';
import { AccountModel, KhachHang, NhanVien } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const BasicInfoTab = ({ formState: { state, actions } }: BasicInfoTabProps) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          fromFieldClassName='w-[175px]'
          toFieldClassName='w-[175px]'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeFieldV2 label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' labelClassName='w-40' />

      {/* Loại hóa đơn */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Loại xuất</Label>
        <FormField
          name='ma_ngv'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: '', label: 'Tất cả' },
            { value: '3', label: '3. Hóa đơn kiêm phiếu xuất' },
            { value: '1', label: '1. Hóa đơn' }
          ]}
        />
      </div>

      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Giao dịch</Label>
        <FormField
          name='ma_gd'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: '', label: 'Tất cả' },
            { value: 'BH', label: 'BH. Bán hàng ngoài' },
            { value: 'NB', label: 'NB. Bán nội bộ' },
            { value: 'XK', label: 'XK. Khác' },
            { value: 'PO', label: 'PO. Bán hàng POS' }
          ]}
        />
      </div>

      {/* Mã khách hàng */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          onRowSelection={actions.setKhachHang}
          value={state.khachHang?.customer_code}
          relatedFieldValue={state.khachHang?.customer_name}
          className='w-100'
        />
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Tài khoản nợ</Label>
        <SearchField<AccountModel>
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          onRowSelection={actions.setTaiKhoanNo}
          value={state.taiKhoanNo?.code}
          relatedFieldValue={state.taiKhoanNo?.name}
          className='w-100'
        />
      </div>

      {/* Mã nhân viên */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Mã nhân viên</Label>
        <SearchField<NhanVien>
          searchEndpoint={`/${QUERY_KEYS.NHAN_VIEN}/`}
          searchColumns={nhanVienSearchColumns}
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          dialogTitle='Danh mục nhân viên bán hàng'
          onRowSelection={actions.setNhanVien}
          value={state.nhanVien?.ma_nhan_vien}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien}
          className='w-100'
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center gap-3'>
        <Label className='w-40 shrink-0 text-[13px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
